module.exports = __webpack_public_path__ + "img/LUB00392.57b3ffda.png";